/*
 *
 * CallUsModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 09-Jan-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  callUs: <PortalMessage id='t.app.support.callUs' defaultMessage='Chiamaci' />,
  callUsCTA: <PortalMessage id='t.app.support.callUs.cta' defaultMessage='Chiama' />,
  goToAssistance: <PortalMessage id='t.app.support.callUs.goToAssistance' defaultMessage='Vai in assistenza' />,
  callUsCTANB: <PortalMessage id='t.app.support.callUs.ctaNB' defaultMessage='Chiama il servizio clienti' />,
  shopName: (
    <PortalMessage
      id='t.app.support.callUs.shop'
      defaultMessage='Stabilimento'
    />
  ),
  shopCode: (
    <PortalMessage
      id='t.app.support.callUs.shopCode'
      defaultMessage='Codice stabilimento'
    />
  ),
  terminalLabel: (
    <PortalMessage
      id='t.app.support.callUs.terminal'
      defaultMessage='Terminal ID (TML)'
    />
  ),
  vatLabel: (
    <PortalMessage
      id='t.app.support.callUs.modal.vatLabel'
      defaultMessage='Durante la telefonata ti sarà richiesto di inserire la tua P. IVA / Codice Fiscale:'
    />
  ),
  vatLabelNB: (
    <PortalMessage
      id='t.app.support.callUs.modal.vatLabelNB'
      defaultMessage='P. IVA / Codice Fiscale:'
    />
  ),
  contactLabel: (
    <PortalMessage
      id='t.app.contactLabel'
      defaultMessage='Numero Assistenza'
    />
  ),
  contactNumber: (
    <PortalMessage
      id='t.app.contactNumber'
      defaultMessage='+39 02345448'
    />
  ),
  contactHoursAuto: (
    <PortalMessage
      id='t.app.contactHoursAuto'
      defaultMessage='Servizi automatici: <strong>24 ore su 24, 365 giorni</strong> l’anno'
    />
  ),
  contactHoursOperator: (
    <PortalMessage
      id='t.app.contactHoursOperator'
      defaultMessage='Servizi con operatore: <strong>08:00 - 20:00, lunedì - venerdì</strong>'
    />
  ),
  contactHoursOperatorInfo: (
    <PortalMessage
      id='t.app.support.callUs.contactHoursOperatorInfo'
      defaultMessage='Numero soggetto a tariffazione urbana secondo l’operatore telefonico usato.'
    />
  ),
  footerNBShowPIVA: (
    <PortalMessage
      id='t.app.support.callUs.footerNBShowPIVA'
      defaultMessage='Durante la telefonata ti sarà chiesto di inserire la tua Partita IVA/Codice Fiscale.'
    />
  )
}

export default formattedMessage
